import { useEffect, useRef } from "react";
import { authType, RHYBUS_ACCESS_TOKEN, RHYBUS_REFRESH_TOKEN, USER_LOGIN_SESSIONID } from "../../Configuration";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { keycloakLogout } from "../../authKeycloak";

const Logout = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const hasLoggedOutRef = useRef(false);

  useEffect(() => {
    const type = authType.toLowerCase();
    localStorage.removeItem(USER_LOGIN_SESSIONID);
    if (hasLoggedOutRef.current) return;
    hasLoggedOutRef.current = true;
    localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
    localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
    if (type === "otp") {
      navigate("/otplogin");
    } else if (type === "keycloak") {
      keycloakLogout().catch((error) => {
        console.error("Logout error", error);
      });
    }else{
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin
    }).catch((error) => {
      console.error("Logout error", error);
      navigate("/signout", { replace: true });
    });
   }
  }, [instance]);

  return null;
};

export default Logout;
